import type { ObstacleDef } from '@/game/level';

let clippedObstacle: ObstacleDef | null = null;

export function copyObstacle(def: ObstacleDef): void {
  clippedObstacle = JSON.parse(JSON.stringify(def));
}

export function pasteObstacle(): ObstacleDef | null {
  if (!clippedObstacle) return null;
  return JSON.parse(JSON.stringify(clippedObstacle));
}

export function hasClipboardObstacle(): boolean {
  return clippedObstacle !== null;
}
